import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nested'
})
export class NestedPipe implements PipeTransform {

    constructor() { }

    transform(object: any, key: string): string {
        let keys = key.split('.');
        for (let k of keys) {
            if (!object) break;
            object = object[k];
        }

        return object;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/nested.pipe.ts